module.exports = __webpack_public_path__ + "img/banner1-2.bd54e66b.png";